// extracted by mini-css-extract-plugin
export default {"main":"list-slovwrite_main__inFRB","list":"list-slovwrite_list__3FNzI"};